import gql from 'graphql-tag';

export const getScholarshipsDiscounts = gql`
  query getScholarshipsDiscounts {
    scholarshipsDiscounts {
      bse {
        id
        date
        isDisabled
        percentage
      }
      intercorp {
        id
        date
        isDisabled
        percentage
      }
    }
  }
`;

export const getAgreementInfo = gql`
  query GetAgreementInfo($codigoTramite: Int!, $dniEmpleado: String) {
    agreementInfo(codigoTramite: $codigoTramite, dniEmpleado: $dniEmpleado) {
      requestId
      serviceName
      title
      discount
      cardDate
      startDate
      endDate
      hasPending
      hasInProgress
      cost
      attentionDuration
      beneficiaries {
        id
        name
      }
      validations {
        description
        isValid
        message
      }
      isEnabled
      isExpired
      steps {
        order
        name
      }
    }
  }
`;

export const registerAgreement = gql`
  mutation RegisterAgreement($input: RegisterAgreementInput!) {
    registerAgreement(input: $input) {
      id
      state
      msg
      msgError
    }
  }
`;
